import React from 'react';
import MonoAvatar from '../../MonoAvatar';
import {
  InlineShell,
  InlineEyebrow,
  formatRelativeShort,
  type F8CardData,
  type OnAction,
} from './cardHelpers';

interface Conversation {
  chatId?: string;
  participantName?: string;
  participantAvatar?: string | null;
  lastMessage?: string;
  unreadCount?: number;
  lastMessageAt?: any;
}

function ConversationRow({
  convo,
  onAction,
}: {
  convo: Conversation;
  onAction?: OnAction;
}) {
  const name = convo.participantName || 'Unknown';
  const photo = convo.participantAvatar;
  const last = convo.lastMessage || '';
  const unread = convo.unreadCount || 0;
  const when = formatRelativeShort(convo.lastMessageAt);

  return (
    <button
      type="button"
      className="f8c-conv-row"
      onClick={() =>
        onAction?.({
          action: 'navigate',
          params: { screen: 'Conversation', chatId: convo.chatId },
        })
      }
    >
      {photo ? (
        <img className="f8c-conv-avatar" src={photo} alt={name} />
      ) : (
        <MonoAvatar name={name} size={40} />
      )}

      <div className="f8c-conv-body">
        <div className="f8c-conv-top">
          <span className="f8c-conv-name">{name}</span>
          {when && <span className="f8c-conv-when">{when}</span>}
        </div>
        {last && (
          <div className={`f8c-conv-last${unread > 0 ? ' f8c-conv-last-unread' : ''}`}>
            {last}
          </div>
        )}
      </div>

      {unread > 0 && (
        <span className="f8c-conv-unread">{unread > 99 ? '99+' : unread}</span>
      )}
    </button>
  );
}

export default function ConversationsListCard({
  card,
  onAction,
}: {
  card: F8CardData;
  onAction?: OnAction;
}) {
  const conversations: Conversation[] = card?.data?.conversations || [];
  if (conversations.length === 0) return null;

  return (
    <InlineShell>
      <InlineEyebrow label={`${conversations.length} conversations`} />
      <div className="f8c-conv-list">
        {conversations.map((convo, i) => (
          <ConversationRow key={convo.chatId || i} convo={convo} onAction={onAction} />
        ))}
      </div>
    </InlineShell>
  );
}
